import { render, staticRenderFns } from "./TicketEventDataGrid.vue?vue&type=template&id=5749c9e5&scoped=true&"
import script from "./TicketEventDataGrid.vue?vue&type=script&lang=js&"
export * from "./TicketEventDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5749c9e5",
  null
  
)

export default component.exports